import { NgModule } from '@angular/core';
import { MatDialogModule as MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule as MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';

import { CustomTimeRangeComponent } from './../pages/page-service/booking-tabs/single-date-inlinePicker/componenets/custom-timeRange/custom-timeRange.component';
import { TimeslotViewComponent } from './../pages/page-service/booking-tabs/single-date-inlinePicker/componenets/timeslot-view/timeslot-view.component';
import { TimeFromToComponent } from './../pages/page-service/booking-tabs/time-from-to/time-from-to.component';
import { RealEstateCardComponent } from './components/realestate-card/realestate-card.component';

// modules (angular)
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';



// modules (third-party)
import { ModalModule } from 'ngx-bootstrap/modal';
import { CarouselModule } from 'ngx-owl-carousel-o';

// components
import { MatExpansionModule } from '@angular/material/expansion';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ProductOptionsComponent } from '../pages/page-product/product-options/product-options.component';
import { ProductComponent } from '../pages/page-product/product/product.component';
import { AddressInformationComponent } from './components/address-information/address-information.component';
import { AlertComponent } from './components/alert/alert.component';
import { AskVendorComponent } from './components/ask-vendor/ask-vendor.component';
import { IconComponent } from './components/icon/icon.component';
import { InputNumberComponent } from './components/input-number/input-number.component';
import { LoadingBarComponent } from './components/loading-bar/loading-bar.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PostCardComponent } from './components/post-card/post-card.component';
import { ProductCardComponent } from './components/product-card/product-card.component';
import { ProductGalleryComponent } from './components/product-gallery/product-gallery.component';
import { QuickviewComponent } from './components/quickview/quickview.component';
import { RatingComponent } from './components/rating/rating.component';
import { SearchComponent } from './components/search/search.component';
import { ShareButtonsComponent } from './components/share-buttons/share-buttons.component';
import { SocialLinksComponent } from './components/social-links/social-links.component';

// pipes
import { GoogleMapsModule } from '@angular/google-maps';
import { MatNativeDateModule, MatRippleModule, } from '@angular/material/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule as MatRadioModule } from '@angular/material/radio';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { TimeslotPickerNewComponent } from '@app/pages/page-service/booking-tabs-new/timeslot-picker/timeslot-picker-new.component';
import { TimeslotPickerComponent } from '@app/pages/page-service/booking-tabs/timeslot-picker/timeslot-picker.component';
import { ServiceNewComponent } from '@app/pages/page-service/service-product-new/service-new.component';

import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { calendarPickerComponent } from '@pages/page-service/booking-tabs//calendar-picker/calendar-picker.component';
import { DateRangeInlinePickerComponent } from '@pages/page-service/booking-tabs//date-range-inlinePicker/date-range-picker.component';
import { TimePickerComponent } from '@pages/page-service/booking-tabs//time-picker/time-picker.component';
import { ClockTimePickerComponent } from '@pages/page-service/booking-tabs/clock-time-picker/clock-time-picker.component';
import { ClockTimeRangePickerComponent } from '@pages/page-service/booking-tabs/clock-timeRange-picker/clock-timeRange-picker.component';
import { DateRangePickerComponent } from '@pages/page-service/booking-tabs/date-range-picker/date-range-picker.component';
import { MultiDayPickerComponent } from '@pages/page-service/booking-tabs/multi-day-picker/multi-day-picker.component';
import { MatTimepickerModule } from 'mat-timepicker';
import { DpDatePickerModule } from 'ng2-date-picker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { SingleDateInlinePickerComponent } from '../pages/page-service/booking-tabs/single-date-inlinePicker/single-date-inlinePicker.component';
import { ServiceComponent } from '../pages/page-service/service-product/service.component';
import { BookingDetailsViewerComponent } from './components/booking-details/booking-details.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';

import { LoginDialogComponent } from './components/login-dialog/login-dialog.component';
import { OptionsDetailsViewerComponent } from './components/options-details/options-details.component';
import { QuotationDetailsViewerComponent } from './components/quotation-items-details/quotation-details.component';
import { AbsoluteUrlPipe } from './pipes/absolute-url.pipe';
import { ColorTypePipe } from './pipes/color-type.pipe';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';

import { QRCodeModule } from 'angularx-qrcode';
import { BenefitPayDialogComponent } from './components/benefit-pay-dialog/benefit-pay-dialog.component';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}
// RECOMMENDED
import { MatTabsModule as MatTabsModule } from '@angular/material/tabs';


import { PageTitleComponent } from '@app/_components/page-title/page-title.component';

import { WidgetAdvancedSearchComponent } from '@app/blocks/widget-advanced-search/widget-advanced-search.component';
import { ProductVariantsOptionsComponent } from '@app/pages/page-product/product-variants-options/product-variants-options.component';
import { ProfessionalOrderDetailsComponent } from '@app/pages/page-professional/book-professional/componenets/order-details/order-details.component';
import { ProfessionalServiceComponent } from '@app/pages/page-professional/professional-service/professional-service.component';
import { CustomTimeFieldComponent } from '@app/pages/page-service/booking-tabs/single-date-inlinePicker/componenets/custom-timeRange/componenets/custom-time-field/custom-time-field.component';
import { TimeRangeViewComponent } from '@app/pages/page-service/booking-tabs/single-date-inlinePicker/componenets/timeRange-view/timeRange-view.component';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { AddressFormComponent } from './components/address-form/address-form.component';
import { InputNumberNewComponent } from './components/input-number-new/input-number-new.component';
import { RegisterComponent } from './components/login-dialog/componenet/register/register.component';
import { ProductCardNewComponent } from './components/product-card-new/product-card-new.component';
import { ProductGalleryNewComponent } from './components/product-gallery-new/product-gallery-new.component';
import { ProductPropertyCardComponent } from './components/product-property-card/product-property-card.component';
import { ProfessionalCardComponent } from './components/professional-card/professional-card.component';


import { ModalGalleryComponent } from './components/modal-gallery/modal-gallery.component';
import { SVGLoaderComponent } from '@app/_components/svg-loader/svg-loader.component';


@NgModule({
    imports: [
        // modules (angular)
        AccordionModule.forRoot(),
        MatExpansionModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        RouterModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatGridListModule,
        MatDividerModule,
        MatSelectModule,
        MatButtonModule,
        FlexLayoutModule,
        MatInputModule,
        MatIconModule,
        MatRadioModule,
        BsDatepickerModule.forRoot(),
        // modules (third-party)
        CarouselModule,
        NgxDaterangepickerMd.forRoot({
            applyLabel: 'Okay',
            firstDay: 3
        }),
        DpDatePickerModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTimepickerModule,
        ModalModule.forRoot(),
        TranslateModule,
        GoogleMapsModule,
        MatRippleModule,
        /* LocalizeRouterModule.forRoot(routes, {
            parser: {
              provide: LocalizeParser,
              useFactory: (translate, location, settings, http) =>
                  new LocalizeRouterHttpLoader(translate, location, settings, http),
              deps: [TranslateService, Location, LocalizeRouterSettings, HttpClient]
            }
          }), */
        QRCodeModule,
        ModalModule.forRoot(),
        MatTabsModule,
        MatTooltipModule,
        PopoverModule.forRoot(),
        MatSlideToggleModule,
        MatDialogModule,
        SVGLoaderComponent,
        // directives
        // components
        AlertComponent,
        /* IconComponent, */
        InputNumberComponent,
        InputNumberNewComponent,
        LoadingBarComponent,
        PageHeaderComponent,
        PaginationComponent,
        PostCardComponent,
        ProductCardComponent,
        ProductCardNewComponent,
        ProductComponent,
        QuickviewComponent,
        RatingComponent,
        SearchComponent,
        ShareButtonsComponent,
        SocialLinksComponent,
        ProductOptionsComponent,
        ProductVariantsOptionsComponent,
        DateRangePickerComponent,
        DateRangeInlinePickerComponent,
        SingleDateInlinePickerComponent,
        MultiDayPickerComponent,
        CustomTimeRangeComponent,
        BookingDetailsViewerComponent,
        OptionsDetailsViewerComponent,
        QuotationDetailsViewerComponent,
        ClockTimePickerComponent,
        ClockTimeRangePickerComponent,
        ProductGalleryComponent,
        ProductGalleryNewComponent,
        ModalGalleryComponent,
        calendarPickerComponent,
        ServiceComponent,
        TimeFromToComponent,
        ServiceNewComponent,
        AskVendorComponent,
        AddressFormComponent,
        AddressInformationComponent,
        RealEstateCardComponent,
        // pipes
        AbsoluteUrlPipe,
        ColorTypePipe,
        CurrencyFormatPipe,
        ConfirmDialogComponent,
        TimePickerComponent,
        TimeslotPickerComponent,
        TimeslotPickerNewComponent,
        LoginDialogComponent,
        BenefitPayDialogComponent,
        ProductPropertyCardComponent,
        WidgetAdvancedSearchComponent,
        TimeslotViewComponent,
        TimeRangeViewComponent,
        CustomTimeFieldComponent,
        PageTitleComponent,
        ProfessionalServiceComponent,
        ProfessionalOrderDetailsComponent,
        RegisterComponent,
        ProfessionalCardComponent
    ],
    exports: [
        // directives
        DateRangePickerComponent,
        DateRangeInlinePickerComponent,
        TimePickerComponent,
        SingleDateInlinePickerComponent,
        CustomTimeRangeComponent,
        MultiDayPickerComponent,
        BookingDetailsViewerComponent,
        OptionsDetailsViewerComponent,
        QuotationDetailsViewerComponent,
        ClockTimePickerComponent,
        ClockTimeRangePickerComponent,
        CustomTimeFieldComponent,
        ProfessionalServiceComponent,
        ProfessionalOrderDetailsComponent,
        RealEstateCardComponent,
        // components
        AlertComponent,
        InputNumberComponent,
        InputNumberNewComponent,
        LoadingBarComponent,
        PageHeaderComponent,
        PaginationComponent,
        PostCardComponent,
        ProductCardComponent,
        ProductCardNewComponent,
        ProductComponent,
        QuickviewComponent,
        RatingComponent,
        SearchComponent,
        SocialLinksComponent,
        ProductOptionsComponent,
        ProductVariantsOptionsComponent,
        ServiceComponent,
        TimeFromToComponent,
        ServiceNewComponent,
        ProductGalleryComponent,
        ProductGalleryNewComponent,
        ModalGalleryComponent,
        AskVendorComponent,
        AddressFormComponent,
        AddressInformationComponent,
        PageTitleComponent,
        ProfessionalCardComponent,
        MatIconModule,
        MatRippleModule,
        // pipes
        AbsoluteUrlPipe,
        ColorTypePipe,
        CurrencyFormatPipe,
        ShareButtonsComponent,
        TimeslotPickerComponent,
        TimeslotPickerNewComponent,
        TranslateModule,
        ProductPropertyCardComponent,
        WidgetAdvancedSearchComponent,
        SVGLoaderComponent
    ]
})
export class SharedModule { }
